import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=809081ce&scoped=true&"
import script from "./Header.js?vue&type=script&lang=js&"
export * from "./Header.js?vue&type=script&lang=js&"
import style0 from "./Header.scss?vue&type=style&index=0&id=809081ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809081ce",
  null
  
)

export default component.exports